export const normalizePath = (pathname: string) => {
  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};
